/* import __COLOCATED_TEMPLATE__ from './ai-insights.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import generateUUID from 'embercom/lib/uuid-generator';

interface Args {
  /**
   * Size of the icon in pixels (width and height)
   * @default "16"
   */
  size?: 'tiny' | 'default' | number;
}

interface Signature {
  Element: SVGSVGElement;
  Args: Args;
}

export default class AiInsightsIcon extends Component<Signature> {
  readonly gradientId = `ai-insights-gradient-1-${generateUUID()}`;
  get size() {
    if (this.args.size === 'default' || !this.args.size) {
      return '16';
    }
    if (this.args.size === 'tiny') {
      return '12';
    }
    return this.args.size;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Common::Icons::AiInsights': typeof AiInsightsIcon;
    'common/icons/ai-insights': typeof AiInsightsIcon;
  }
}
